/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPNATUREOFPERSON } from './IAPNATUREOFPERSON';
import {
    IAPNATUREOFPERSONFromJSON,
    IAPNATUREOFPERSONFromJSONTyped,
    IAPNATUREOFPERSONToJSON,
} from './IAPNATUREOFPERSON';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface TrustPartyDetailsViewModel
 */
export interface TrustPartyDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof TrustPartyDetailsViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof TrustPartyDetailsViewModel
     */
    natureOfTrustId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof TrustPartyDetailsViewModel
     */
    areAllBeneficiariesIndividuals?: IAPYESORNO;
    /**
     * 
     * @type {string}
     * @memberof TrustPartyDetailsViewModel
     */
    registeredName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrustPartyDetailsViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof TrustPartyDetailsViewModel
     */
    countryOfRegistration?: IAPCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof TrustPartyDetailsViewModel
     */
    dateOfRegistration?: Date;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof TrustPartyDetailsViewModel
     */
    countryOfOperation?: IAPCOUNTRY;
}

/**
 * Check if a given object implements the TrustPartyDetailsViewModel interface.
 */
export function instanceOfTrustPartyDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrustPartyDetailsViewModelFromJSON(json: any): TrustPartyDetailsViewModel {
    return TrustPartyDetailsViewModelFromJSONTyped(json, false);
}

export function TrustPartyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrustPartyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'natureOfTrustId': !exists(json, 'NatureOfTrustId') ? undefined : IAPNATUREOFPERSONFromJSON(json['NatureOfTrustId']),
        'areAllBeneficiariesIndividuals': !exists(json, 'AreAllBeneficiariesIndividuals') ? undefined : IAPYESORNOFromJSON(json['AreAllBeneficiariesIndividuals']),
        'registeredName': !exists(json, 'RegisteredName') ? undefined : json['RegisteredName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'countryOfRegistration': !exists(json, 'CountryOfRegistration') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfRegistration']),
        'dateOfRegistration': !exists(json, 'DateOfRegistration') ? undefined : (new Date(json['DateOfRegistration'])),
        'countryOfOperation': !exists(json, 'CountryOfOperation') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfOperation']),
    };
}

export function TrustPartyDetailsViewModelToJSON(value?: TrustPartyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'NatureOfTrustId': IAPNATUREOFPERSONToJSON(value.natureOfTrustId),
        'AreAllBeneficiariesIndividuals': IAPYESORNOToJSON(value.areAllBeneficiariesIndividuals),
        'RegisteredName': value.registeredName,
        'RegistrationNumber': value.registrationNumber,
        'CountryOfRegistration': IAPCOUNTRYToJSON(value.countryOfRegistration),
        'DateOfRegistration': value.dateOfRegistration === undefined ? undefined : (value.dateOfRegistration.toISOString()),
        'CountryOfOperation': IAPCOUNTRYToJSON(value.countryOfOperation),
    };
}

